<template>
  <div class="w-100 d-flex align-items-start mb-3">
    <eg-b-button :to="to" class="btn go-back-link p-0 d-flex p-0">
      <eg-b-icon :icon="icon" class="mr-2" />
      <span>{{ label }}</span>
    </eg-b-button>
  </div>
</template>

<script>
export default {
  name: "GoBackButton",
  props: {
    to: {
      type: [String, Object],
      default: "/",
    },
    label: {
      type: String,
      default: "Back to Home",
    },
    icon: {
      type: String,
      default: "arrow-left",
    },
  },
};
</script>

<style lang="scss" scoped>
.go-back-link {
  font-family: "Inter";
  font-size: var(--typography-font-size-fs-300);
  font-weight: var(--typography-font-weight-fw-500);
  align-items: center;
  background: transparent;
  border: none;
  outline: none;

  &:focus,
  &:active:focus,
  &:hover,
  &:active {
    background: transparent;
    border: none;
    outline: none;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem var(--purple-100);
  }
}
</style>
